import { render, staticRenderFns } from "./FactorCard.vue?vue&type=template&id=61718891&"
import script from "./FactorCard.vue?vue&type=script&lang=js&"
export * from "./FactorCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports